
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const glaz: Operator = {
	id: 'glaz',
	name: 'Glaz',
	role: 'Attacker',
	org: 'SPETSNAZ',
	squad: 'GHOSTEYES',
	ratings: {
		health: 1,
		speed: 3,
		difficulty: 2
	},
	meta: {
		gender: 'm',
		country: 'ru',
		season: 'Release',
		height: 178,
		weight: 79,
		price: {
			renown: 1000,
			r6credits: 0
		}
	},
	bio: {
		real_name: 'Timur Glazkov',
		birthplace: 'Vladivostok, Russia'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#a62222"></path><circle cx="175" cy="175" r="56" style="fill:#fff"></circle><path d="M175 79.5c-52.743 0-95.5 42.757-95.5 95.5s42.757 95.5 95.5 95.5 95.5-42.757 95.5-95.5-42.757-95.5-95.5-95.5m0 184.5c-49.153 0-89-39.847-89-89s39.847-89 89-89 89 39.847 89 89-39.847 89-89 89" style="fill:#fff"></path><path d="M243.475 171.75h-41.173c-1.483-12.588-11.464-22.569-24.052-24.052v-41.031h-6.5v41.031c-12.588 1.483-22.569 11.464-24.052 24.052h-41.173a.1.1 0 0 0-.1.1v6.3a.1.1 0 0 0 .1.1h41.173c1.483 12.588 11.464 22.569 24.052 24.052v41.031h6.5v-41.031c12.588-1.483 22.569-11.464 24.052-24.052h41.173a.1.1 0 0 0 .1-.1v-6.3a.1.1 0 0 0-.1-.1M175 180.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 1 1 0 11M35.75 167.251h60.5v15.498h-60.5z"></path><path d="M35.75 171.75h60.5v6.499h-60.5z" style="fill:#fff"></path><path d="M253.75 167.251h60.5v15.498h-60.5z"></path><path d="M253.75 171.75h60.5v6.499h-60.5z" style="fill:#fff"></path><path d="M182.749 35.75v60.5h-15.498v-60.5z"></path><path d="M144.75 62.75h60.5v6.499h-60.5z" style="fill:#fff" transform="rotate(90 175 66)"></path><path d="M182.749 253.75v60.5h-15.498v-60.5z"></path><path d="M144.75 280.75h60.5v6.499h-60.5z" style="fill:#fff" transform="rotate(90 175 284)"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-glaz'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
